import { BlockGroup } from '@app/components/cms/blockGroup';
import { mapSectionDtoToGroupsWithBlocks } from '@app/logic/pages';
import { Cms } from '@typings';
import cx from 'classnames';
import React from 'react';

import { getSectionClassnames } from './getSectionClassnames';
import styles from './section.module.scss';

interface Props {
  sectionData: Cms.SectionDTO;
  className?: string;
}

export const Section = React.memo((props: Props) => {
  const { sectionData, className } = props;
  const sectionClassNames = getSectionClassnames(sectionData.visibleFor);
  const classNames = cx(sectionClassNames, className);
  const orderedGroups: Cms.GroupWithBlocks[] = React.useMemo(() => mapSectionDtoToGroupsWithBlocks(sectionData), [sectionData]);

  return (
    <div id={sectionData.id} className={cx(styles.section, classNames)}>
      {orderedGroups.map((group, index) => (
        <BlockGroup key={group.id} group={group} section={sectionData} groupIndex={index} />
      ))}
    </div>
  );
});
